(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        var resolve = {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('campaign');
                $translatePartialLoader.addPart('flyers');
                $translatePartialLoader.addPart('campaigns');
                $translatePartialLoader.addPart('seller-campaigns');
                $translatePartialLoader.addPart('bag');
                $translatePartialLoader.addPart('invoice');
                $translatePartialLoader.addPart('global');
                $translatePartialLoader.addPart('store-management');
                $translatePartialLoader.addPart('checklist');
                return $translate.refresh();
            }]
        };

        $stateProvider
            .state('campaign', {
                parent: 'admin',
                url: '/campaigns',
                data: {
                    authorities: ['READ_STORE_CAMPAIGNS', 'ADMIN_HUB'],
                    pageTitle: 'campaign.list.title.plural'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/campaign/campaigns.html',
                        controller: 'CampaignsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    type: null
                },
                resolve: resolve
            }).state('campaign.new', {
                url: '/new',
                data: {
                    authorities: ['READ_STORE_CAMPAIGNS', 'ADMIN_HUB'],
                    pageTitle: 'campaign.new.title.singular'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/campaign/campaign/campaign.html',
                        controller: 'CampaignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: resolve
            }).state('campaign.distribute', {
                url: '/{id}/distribute',
                data: {
                    authorities: ['ADMIN_HUB'],
                    pageTitle: 'campaign.actions.distribute'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/hub-management/campaign/hub-campaign-distribute.html',
                        controller: 'HubCampaignDistributeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: resolve
            }).state('campaign.duplicate', {
                url: '/{id}/duplicate',
                data: {
                    authorities: ['READ_STORE_CAMPAIGNS', 'ADMIN_HUB'],
                    pageTitle: 'campaign.action.duplicate'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/campaign/campaign/campaign.html',
                        controller: 'CampaignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: resolve
            });
    }
})();
